import React from "react";
import classes from './input.module.scss'

const Input = ({ placeholder, name, item, onChangeHandler, index, parentData, value }) => {
    return <span>
      <input
        onChange={(e) => onChangeHandler(e.target.value, item, index, parentData)}
        value={value || value === 0 ? value : ''}
        placeholder={placeholder}
        className={classes.primary_input}
        name={name}
      />
  </span>;
};

export default Input;
